import _trim from "lodash/trim";
import _isString from "lodash/isString";
import { NULL } from "../../../../constants";
export default (function (_ref) {
  var operator = _ref.operator,
      values = _ref.values;

  if (values && values.length) {
    values = values.map(function (value) {
      if (value === NULL) {
        return null;
      }

      if (_isString(value)) {
        return _trim(value);
      }

      return value;
    });
  }

  return {
    operator: operator,
    values: values
  };
});